function ThirdChapter() {
  return (
    <>
      <article>
        <h1>TYPY PŘIPOJENÍ</h1>
        <p>
          Typy připojení je třetí ze čtyř témat, která aplikace zpracovává. Žák
          se v kapitole seznámí s různými druhy připojení k internetu. V
          aktivitách jsou postupně rozebrány jak, jednotlivé druhy připojení,
          tak jejich vlastnosti. Aktivity jsou koncipované tak, aby si žák
          dokázal představit, jaký vliv mají tyto vlastnosti na přenos dat v
          reálném světě. Žák by měl před zahájením aktivit v této kapitole znát
          základní prvky, ze kterých se skládá počítačová síť (klient, server,
          chytrá křižovatka a cesta pro informace) a měl by vědět, že data jsou
          přenášena v paketech po cestách určených pro přenos informací.
        </p>
      </article>
      <article>
        <h1>Kabely</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by se měl v rámci aktivity blíže seznámit s nejběžnějším
            způsobem přenosu dat (kabely).
          </li>
          <li>
            Žák by měl být schopen srovnat vlastnosti optických a metalických
            kabelů.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          V úvodu se žák dozví o rozdílech mezi metalickými a optickými kabely.
          Vizualizace by měla žákovi ulehčit představu o tom, jak výrazný rozdíl
          je v rychlosti přenosu dat skrz optické a metalické kabely. Paket
          přenášený optickým kabelem má na první pohled daleko vyšší rychlost
          než paket posílaný přes kabel metalický.
        </p>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Vývoj optických vláken je poměrně intenzivní, proto je možné, že
            informace uvedené v aplikaci nebudou aktuální.
          </p>
        </div>
      </article>
      <article>
        <h1>Wi-Fi</h1>
        <h2>Typ aktivity</h2>
        <p>Úkol</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>Žák by se měl seznámit s pojmy Wi-Fi router a Wi-Fi signál.</li>
          <li>
            Žák by mě pochopit, jak je realizované propojení klienta se zbytkem
            internetu skrz Wi-Fi signál.
          </li>
        </ul>
        <h2>Zadání</h2>
        <p>
          Žák je v úvodu seznámen s pojmem Wi-Fi router a Wi-Fi signál. Následně
          je vysvětlen princip, jakým jsou data posílaná dále do internetu.
          Následuje úkol, kdy žák podle instrukcí zapojí Wi-Fi router umístěný v
          domě a umožní tak domácnosti získat přístup k internetu.
        </p>
        <h2>Řešení</h2>
        <p>
          Žák musí nejdříve zapojit Wi-Fi router do zásuvky. Poté, co je router
          napájen, je možné ho zapnout. V tu chvíli se zobrazí IP adresa Wi-Fi v
          dostupných zařízeních. Zde je dobré upozornit, že Wi-Fi stále nemá
          přístup internetu a že musí následovat poslední krok, kdy Wi-Fi (teď
          už pomocí kabelu) připojíme k nejbližší chytré křižovatce, čímž získá
          přístup do celé sítě.
        </p>
        <div class="image wifi"></div>
        <div class="note">
          {" "}
          <h2>Poznámky</h2>
          <p>
            Následující aktivitu je možné realizovat i přímo ve třídě s
            opravdovým routerem.
          </p>
          <p>
            Žáci mají tendenci odhazovat doposud získané znalosti o tom, co je
            to internet. Řada z nich má totiž představu, že Wi-Fi rovná se
            internet. Hrozí tak riziko, že žák přestane pracovat s tím, co se
            doposud naučil a vrátí se ke své původní představě. V rámci aktivity
            je tudíž doporučeno provázat nové informace s tím, co již ví
            například z aktivity Putování informací.
          </p>
          <p>
            V aktivitě Putování informací jsme zmínili dělení křižovatek na
            routery a switche. Je možné se k tomuto dělení vrátit a propojit
            žákům tuto starou informaci s novou terminologií Wi-Fi router.
          </p>
        </div>
      </article>
      <article>
        <h1>Mobilní data</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>Žák by se měl seznámit s pojmy BTS věž a mobilní signál.</li>
          <li>
            Žák by mě pochopit, jak je realizované propojení klienta se zbytkem
            internetu skrz mobilní signál.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          Žák je v úvodu seznámen s pojmem BTS věž a mobilní signál. Následně je
          vysvětlen princip, jakým jsou data posílaná pomocí mobilního signálu
          dále do internetu. Následuje vizualizace, která by měla žákovi
          usnadnit představu o tom, jakým způsobem probíhá přenos dat pomocí
          mobilního signálu. Vizualizace znázorňuje cestu paketu, který je
          odeslán pomocí mobilního signálu k BTS věži. Poté následuje klasická
          cesta paketu až k serveru, kterou by měl žák znát z dřívějších
          aktivit.
        </p>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Po této aktivitě doporučujeme s žáky použít{" "}
            <a target="_blank" href="https://gsmweb.cz/mapa/">
              mapu výskytů BTS věží
            </a>
            . Žáci opět získají reálnější představu o tomto způsobu připojení.
            Pokud se některá BTS věž nachází ve vaší blízkosti, můžete ji s žáky
            navštívit.
          </p>
        </div>
      </article>
      <article>
        <h1>Satelit</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>Žák by se měl seznámit s pojmem satelit.</li>
          <li>
            Žák by mě pochopit, jak je realizované propojení klienta se zbytkem
            internetu skrz satelitní připojení.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          Žák je v úvodu seznámen s pojmem satelit. Následně je vysvětlen
          princip, jakým jsou data posílaná pomocí satelitu dále do internetu.
          Následuje vizualizace, která by měla žákovi usnadnit představu o tom,
          jakým způsobem probíhá přenos dat pomocí satelitu. Vizualizace
          znázorňuje cestu paketu, který je odeslán směrem k satelitu na oběžnou
          dráhu. Poté je paket nasměrován zpět k zemskému povrchu, kde je
          zachycen, a klasickým způsobem, který by měl žák znát z dřívějších
          aktivit, dopraven až k serveru.
        </p>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Žák je v úvodu seznámen s pojmem satelit. Následně je vysvětlen
            princip, jakým jsou data posílaná pomocí satelitu dále do internetu.
            Následuje vizualizace, která by měla žákovi usnadnit představu o
            tom, jakým způsobem probíhá přenos dat pomocí satelitu. Vizualizace
            znázorňuje cestu paketu, který je odeslán směrem k satelitu na
            oběžnou dráhu. Poté je paket nasměrován zpět k zemskému povrchu, kde
            je zachycen, a klasickým způsobem, který by měl žák znát z
            dřívějších aktivit, dopraven až k serveru.
          </p>
          <p>
            Ukazuje se, že žáci mají stále představu satelitu jako hlavního
            přenosového média. Z tohoto důvodu je možné navázat na vizualizaci
            debatou, ve které by mohly zaznít otázky jako „Kolik kilometrů navíc
            musí urazit paket přenášený satelitem oproti paketu přenášeném
            kabelem?“ nebo „Jak dopadne přenos v případě nepřízně počasí?“.
            Otázky by žáky měly navést k tomu, že tento způsob přenosu ve
            srovnání s kabely není optimální.
          </p>
          <p>
            Doporučujeme sledovat aktuální informace o Starlink a dalších
            technologiích. S rozvojem podobných technologií je možné, že
            informace uvedené v aplikaci již nebudou nadále aktuální. Už v
            současnosti jsou například družice schopné přeposílat signál mezi
            sebou bez nutnosti odrazit ho zpět k povrchu země (byť se nejedná o
            standard).
          </p>
        </div>
      </article>
      <article>
        <h1>Doba odezvy</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by si měl uvědomit, že pojem rychlost internetu zahrnuje více
            aspektů.
          </li>
          <li>
            Žák by měl získat představu o tom, jak souvisí doba odezvy s
            přenosem dat.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          Žák je nejprve seznámen s různými aspekty rychlosti internetu.
          Následně je žákovi představen pojem doba odezvy. V rámci vizualizace
          si vyzkouší, jak se změří doba odezvy v konkrétní síti. Žák má za úkol
          postupně klikat na všechny uzly na cestě od klienta až do serveru. Ve
          chvíli, kdy klikne na poslední uzel (server), je zobrazen celkový čas,
          který byl potřeba na cestu od klienta do serveru. Žákův čas je
          následně porovnán s optimální dobou odezvy v roce 2023 aby došlo k
          lepšímu zasazení do kontextu reality.
        </p>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Aktivita v podstatě simuluje ping test. Aby žáci získali reálnou
            představu o době odezvy v reálném prostředí, doporučujeme v
            návaznosti na tuto aktivitu vyzkoušet libovolný{" "}
            <a target="_blank" href="https://traceroute-online.com/">
              online ping test
            </a>{" "}
            . Zároveň je užitečné sledovat geografickou polohu serverů, vůči
            kterým měříte dobu odezvy, a srovnávat, jak doba odezvy souvisí se
            vzdálenosti.
          </p>
          <p>
            S pokročilejšími žáky můžete spouštět příkaz ping i skrz{" "}
            <a
              target="_blank"
              href="https://learn.microsoft.com/en-us/windows-server/administration/windows-commands/ping"
            >
              terminál
            </a>
            .
          </p>
        </div>
      </article>
      <article>
        <h1>Šířka pásma</h1>
        <h2>Typ aktivity</h2>
        <p>Vizualizace</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by měl získat představu o tom, jak souvisí šířka pásma, jako
            druhý aspekt rychlosti internetu, s přenosem dat.
          </li>
          <li>
            Zároveň by měl získat konkrétní představu o tom, co znamená jednotka
            Mb/s.
          </li>
        </ul>
        <h2>Popis vizualizace</h2>
        <p>
          Na začátku je žák seznámen s pojmem šířka pásma. Pojem je rovněž dán
          do souvislosti s dobou odezvy. Následuje vizualizace, která má žákovi
          nový termín lépe představit. V rámci aktivity by mělo rovněž dojít k
          lepší představě toho, co znamená jednotka Mb/s. Žák má za úkol za 10
          sekund správně přepsat co největší množství znaků. Po uběhnutí 10
          sekund se zobrazí počet znaků a hrubý odhad toho, kolik Mb dat to je
          (čímž žák získá lepší představu o této jednotce).
        </p>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Po dokončení této aktivity doporučujeme s žáky vyzkoušet jakýkoliv{" "}
            <a target="_blank" href="https://www.speedtest.net/">
              online speed test
            </a>
            .
          </p>
          <p>
            V rámci mezipředmětových vztahů můžete tuto a předchozí aktivitu
            propojit s fyzikou. Řekněte žákům pouze jednotky dvou zmíněných
            aspektů rychlosti a nechte je odvodit, čeho se asi daný aspekt bude
            týkat.
          </p>
          <p>
            Analogie s vodovodním potrubím může být doplněna o jinou analogii se
            silnicí a automobily. Cesta je kabel a auta jsou data. Šířka pásma
            by reprezentoval počet pruhů na silnici, čím širší bude cesta, tím
            více aut může najednou projet. Dobu odezvy reprezentuje doba, kterou
            nám zabere dojet z jednoho místa na druhé. To lze vylepšit tak, že
            zvýšíte povolenou rychlost na silnici. Jde ale vidět, že to není
            jediný faktor, který tento aspekt ovlivňuje – když bude vysoká
            povolená rychlost, ale silnice bude ucpaná, tak nám to nepomůže a
            doba, kterou strávíme na cestě, bude velká.
          </p>
        </div>
      </article>
      <article>
        <h1>Omezená vzdálenost</h1>
        <h2>Typ aktivity</h2>
        <p>Úkol</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by měl získat představu o různém dosahu signálu jednotlivých
            druhů připojení.
          </li>
        </ul>
        <h2>Zadání</h2>
        <p>
          Žák má za úkol připojit všechny klienty k internetu. K dispozici má
          dvě BTS věže a dva Wi-Fi routery. Zařízení přidá do mapy kliknutím,
          následně je může v mapě libovolně přesouvat. V případě, že je klient v
          dosahu zařízení, objeví se mu nad hlavou ikonka Wi-Fi.
        </p>
        <h2>Řešení</h2>
        <p>
          Žák by měl v rámci řešení úkolu především odhalit, že BTS věž má větší
          dosah než Wi-Fi router. Ve chvíli, kdy se mu podaří připojit všechny
          klienty, objeví se navazující text, ve kterém je srovnán reálný dosah
          zařízení včetně satelitů.
        </p>
        <div class="image omezena-vzdalenost"></div>
        <div class="note">
          <h2>Poznámky</h2>
          <p>
            Kvůli přehlednosti zde nebyly přidány žádné další prvky sítě. Žáci
            by ale stále měli mít na paměti, že jak BTS věž, tak Wi-Fi router je
            připojen k chytré křižovatce, která kabely přeposílá data dále.
          </p>
        </div>
      </article>
      <article>
        <h1>Jak se připojit</h1>
        <h2>Typ aktivity</h2>
        <p>Úkol</p>
        <h2>Co se žák naučí</h2>
        <ul>
          <li>
            Žák by měl propojit doposud získané informace o různých typech
            připojení.
          </li>
        </ul>
        <h2>Zadání</h2>
        <p>
          Žák má za úkol vybrat vhodný typ připojení v různých situacích ze
          života. Na výběr má vždy ze tří možností, přičemž správně může být i
          více odpovědí.
        </p>
        <h2>Řešení</h2>
        <div class="image jak-se-pripojit"></div>
        <p></p>
        <div class="note">
          {" "}
          <h2>Poznámky</h2>
          <p>
            Je možné, že žáci nebudou znát připojení počítače pomocí kabelu.
            Doporučujeme proto tuto možnost ukázat na fyzickém zařízení, aby
            žáci získali lepší představu. Rovněž je dobré zmínit možnost
            redukcí, v případě že nemají vhodný konektor.
          </p>
        </div>
      </article>
    </>
  );
}

export default ThirdChapter;
